import { createApiSlice } from "@common";
import {
  CURD_ACCOUNT,
  CURD_ACCOUNT_BY_ID,
  CURD_ACCOUNT_BY_OWNER,
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addAccount",
    method: "post",
    url: CURD_ACCOUNT,
    stateKey: "message",
  },
  {
    name: "getAccount",
    method: "get",
    url: CURD_ACCOUNT,
    stateKey: "data",
  },
  {
    name: "getAccountByOwner",
    method: "get",
    url: CURD_ACCOUNT_BY_OWNER,
    stateKey: "data",
  },
  {
    name: "updateAccount",
    method: "put",
    url: CURD_ACCOUNT,
    stateKey: "message",
  },
  {
    name: "deleteAccount",
    method: "delete",
    url: CURD_ACCOUNT,
    stateKey: "message",
  },
  {
    name: "getAccountDetails",
    method: "get",
    url: CURD_ACCOUNT_BY_ID,
    stateKey: "details",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    details: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "account",
  apiConfig,
  customReducers,
);
const accountSlice = slice;
// Export the slice's reducer
export default accountSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addAccount,
  getAccount,
  getAccountByOwner,
  updateAccount,
  deleteAccount,
  getAccountDetails
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
